const nativeJSInterfaceBridge = function (getInjected) {
  return {
    install(Vue) {
      Vue.prototype.$deepLinkProtocol = process.env.VUE_APP_DEEP_LINK_PROTOCOL
      Vue.prototype.$baeminActionDeepLinkProtocol = process.env.VUE_APP_BAEMIN_ACTION_DEEP_LINK_PROTOCOL
      Vue.prototype.$getNativeData = getInjected
      Vue.prototype.$setInjectCallback = function (callback) {
        injectCallback = callback
      }
    }
  }
}

export default nativeJSInterfaceBridge
